'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getAuthorizedSuperAgent = getAuthorizedSuperAgent;

var _superagentBluebirdPromise = require('superagent-bluebird-promise');

var _superagentBluebirdPromise2 = _interopRequireDefault(_superagentBluebirdPromise);

var _superagentCache = require('superagent-cache');

var _superagentCache2 = _interopRequireDefault(_superagentCache);

var _auroraJavascriptUtils = require('@unitedtraders/aurora-javascript-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _superagentCache2.default)(_superagentBluebirdPromise2.default, null, { preventDuplicateCalls: true, expiration: 1 }); // 1 sec

function noOpAuthorizationErrorHandler(error) {
    throw error;
}

function getAuthorizedSuperAgent(authorizationHeaderProvider) {
    var authorizationErrorHandler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noOpAuthorizationErrorHandler;

    _auroraJavascriptUtils.assert.func(authorizationHeaderProvider);

    var Request = _superagentBluebirdPromise2.default.Request;
    var originalPromise = _auroraJavascriptUtils.assert.func(Request.prototype.promise);

    function authorizedPromise() {
        var _this = this,
            _arguments = arguments;

        return authorizationHeaderProvider().then(function (authorizationHeader) {
            if (authorizationHeader) {
                _this.set('Authorization', authorizationHeader);
            } else {
                _auroraJavascriptUtils.log.warn('When try to getAuthorizedSuperAgent, we has no authorizationHeader!');
            }
        }).catch(function (e) {
            authorizationErrorHandler(e);
        }).then(function () {
            return originalPromise.apply(_this, _arguments);
        });
    }

    Request.prototype.promise = authorizedPromise;

    return _superagentBluebirdPromise2.default;
}


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/application-bootstrapper/dist/superAgentUtils.js
// module id = 1331
// module chunks = 118